import Icon from '@/Icon';

type Props = {
	/** const isCommon = authority === 'USER' */
	isCommon: boolean;
	/** verifyStatus */
	verifyStatus?: boolean;
	className?: string;
};

/**인증 마크 컴포넌트
 * user verifyStatus 는 boolean 이고
 * 비즈니스 여부는 owner 가 business 인 상태를 보고 판단
 *	const isCommon = authority === 'USER'
 * verifyStatus = verifyStatus
 */
export const Cert = ({ isCommon, verifyStatus, className }: Props) => {
	if (!isCommon) return <Icon className={className} path="Sticker_Sticker_24_Business" />;
	if (isCommon && verifyStatus) return <Icon className={className} path="Sticker_Sticker_24_Certify" />;
	return <></>;
};
